import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import html2canvas from 'html2canvas';

import Vant from 'vant';
import 'vant/lib/index.css';

Vue.use(Vant);


import axios from 'axios'
axios.defaults.baseURL = 'https://h5api.xiaoxxx.cn/h5/huaFaPeople';
Vue.prototype.$axios = axios
Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')